export enum ApplicationStatusCodes {
  Atgriezta = 'PL_ATG',
  Izdrukāta = 'PL_IDR',
  Izsniegta = 'PL_IZS',
  Nav_pieprasīta = 'PL_NEP',
  Nodota_drukāšanai = 'PL_NDR',
  Nosūtīta = 'PL_NS',
  Pieprasīta = 'PL_PIEP',
}
